import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';
import {ResourceView} from 'src/modules/entitlements/typedef';

import {presetsStateSelector} from './presets-state.slice';

import type {PresetsFilter} from '../typedef';
import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';


export const presetsSlice = getCachedTableDataSlice<
    {view: ResourceView[], relations: PresetRelationItem[]},
    undefined,
    undefined,
    PresetsFilter
>('presets');

export const presetsActions = presetsSlice.actions;
const presetsCacheSelector: CachedTableCacheSelector<{view: ResourceView[], relations: PresetRelationItem[]}>
    = state => state.manageEntitlements.presetsReducer.presets.cache;
export const presetsDataSelector: CachedTableDataSelector<{view: ResourceView[], relations: PresetRelationItem[]}>
    = state => state.manageEntitlements.presetsReducer.presets;
export const presetsResultSelector = getCachedTableResultSelector(
    presetsCacheSelector,
    presetsStateSelector,
);
